import axiosInstance from "./api_helper";

export const createPurchase = async (purchaseData) => {
  try {
    const response = await axiosInstance.post('/api/bon-commandes', JSON.stringify(purchaseData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const updatePurchase = async (id, purchaseData) => {
  try {
    const response = await axiosInstance.put(`/api/bon-commandes/${id}`, JSON.stringify(purchaseData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const validerBC = async (id) => {
  try {
    const response = await axiosInstance.put(`/api/bon-commandes/${id}/valider`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const search = async ({ fournisseurId, dateFrom, dateTo, query, notReceptioned }) => {
  try {
    const response = await axiosInstance.get(`/api/bon-commandes/search`, {
      params: {
        query,
        fournisseurId,
        dateFrom,
        dateTo,
        notReceptioned
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const generatePurchaseReport = async ({supplierId, dateDebut, transporteurId, dateFin, query, page = 0, size = 25}) => {
  try {
    const response = await axiosInstance.get(`/api/rapports/supplier`, {
      params: {
        supplierId: supplierId,
        dateDebut: dateDebut,
        dateFin: dateFin,
        transporteurId,
        query,
        page,
        size
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPurchasesData = (dateRange) => axiosInstance.get(`/api/purchase-orders/dashboard?dateRange=${dateRange}`);

export const getPurchaseById = async (id) => {
  try {
    const response = await axiosInstance.get(`/api/purchase-orders/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const cancelPurchase = async (id) => {
  try {
    const response = await axiosInstance.post(`/api/purchase-orders/${id}/cancel`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPurchasesByDateRange = async (startDate, endDate, page = 1, size = 10) => {
  try {
    const response = await axiosInstance.get('/api/purchase-orders/search', {
      params: {
        startDate,
        endDate,
        page: page - 1,
        size
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getTotalPurchasesToday = async () => {
  return axiosInstance.get(`/api/purchase-orders/total-purchase-orders/today`);
};

export const getTotalPurchasesThisWeek = async () => {
  return axiosInstance.get(`/api/purchase-orders/total-purchase-orders/this-week`);
};

export const getTotalPurchasesThisMonth = async () => {
  return axiosInstance.get(`/api/purchase-orders/total-purchase-orders/this-month`);
};

export const getTotalPurchasesThisYear = async () => {
  return axiosInstance.get(`/api/purchase-orders/total-purchase-orders/this-year`);
};

export const getTotalPurchasesForDateRange = async (startDate, endDate) => {
  return axiosInstance.get(`/api/purchase-orders/total-purchase-orders`, {
    params: {
      startDate: startDate,
      endDate: endDate
    }
  });
};

export const generateDocument = async (id) => {
  const response = await axiosInstance.get(`/api/purchase-orders/report/${id}`, {
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
}

export const fetchNewOrderNumber = async () => {
  try {
    const response = await axiosInstance.get('/api/bon-commandes/nouveau');
    return response;
  } catch (error) {
    throw error;
  }
};
